import { type CountriesAlpha2 } from '@sequencehq/api'
import { GOCARDLESS_SUPPORTED_END_CUSTOMER_COUNTRIES } from '../../constants'

export const isGoCardlessSupportedEndCustomerCountry = (
  country: CountriesAlpha2
): boolean => {
  return GOCARDLESS_SUPPORTED_END_CUSTOMER_COUNTRIES.includes(country)
}
